import React from "react";

import SvgArrowUpRight from "@uui/ArrowUpRight";

import { Link, LinkProps } from "@rui/Link";
import { Row } from "@rui/Stack/Stack";

const BillingLink = (props: LinkProps) => {
  return (
    <Link sx={{ fontSize: "14px", color: "shades.primary.500" }} {...props}>
      <Row variant="right">
        {props.children}
        {props.href && <SvgArrowUpRight fontSize="inherit" sx={{ ml: 0.5 }} />}
      </Row>
    </Link>
  );
};

export default BillingLink;
